export default __webpack_public_path__ + "static/media/ps_1.c9068283.jpg";